import { RootState } from '@/models/root-state.model';
import { BffCmsWelcomeTextsResponse } from '@lucky7ventures/bff-types';
import { createSelector } from 'reselect';
import parse from 'html-react-parser';
import { isEmpty } from '@/shared/utility';

const selectWelcomeTextsHtml = (state: RootState): BffCmsWelcomeTextsResponse =>
  state.welcomeTexts.welcomeTexts;
export const selectWelcomeTextsHtmlLoading = (state: RootState): boolean =>
  state.welcomeTexts.loading;
export const selectHeroWelcomeTextsHtml = createSelector(selectWelcomeTextsHtml, welcomeTexts =>
  parse(welcomeTexts.hero?.text),
);
export const selectHeroReturningUserWelcomeTextsHtml = createSelector(
  selectWelcomeTextsHtml,
  welcomeTexts => parse(welcomeTexts.heroReturningUser?.text ?? ''),
);

export const selectHomeCenterWelcomeTextsHtml = createSelector(
  selectWelcomeTextsHtml,
  welcomeTexts => parse(welcomeTexts.homeCenter.text),
);
export const selectBonusIntroWelcomeTextsHtml = createSelector(
  selectWelcomeTextsHtml,
  welcomeTexts => parse(welcomeTexts.bonusIntro.text),
);
export const selectExitIntentOffer = createSelector(selectWelcomeTextsHtml, welcomeTexts =>
  !isEmpty(welcomeTexts.ftdExitIntent.text) ? parse(welcomeTexts.ftdExitIntent.text) : undefined,
);
export const selectDocumentTitle = createSelector(selectWelcomeTextsHtml, welcomeTexts =>
  !isEmpty(welcomeTexts.documentTitle.text) ? parse(welcomeTexts.documentTitle.text) : undefined,
);
export const selectDocumentTitleWelcomeTexts = createSelector(
  selectWelcomeTextsHtml,
  welcomeTexts => welcomeTexts.documentTitle.text,
);
